import { Route } from "@angular/router";
import { BusinessCardComponent } from "app/layout/common/business-card/business-card.component";
import { LayoutComponent } from "app/layout/layout.component";
import { InitialDataResolver } from "./app.resolver";
import { AuthGuard } from "./core/guards/auth.guard";
import { NoAuthGuard } from "./core/guards/noAuth.guard";

export const appRoutes: Route[] = [
  { path: "", pathMatch: "full", redirectTo: "home" },

  {
    path: "",
    component: LayoutComponent,
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "error-500",
        loadChildren: () =>
          import("app/modules/general/error/error-500/error-500.routes"),
      },
      {
        path: "error-403",
        loadChildren: () =>
          import("app/modules/general/error/error-403/error-403.routes"),
      },
      {
        path: "shared-gantt",
        loadChildren: () =>
          import("app/modules/project-management/public-gantt/public-gantt.routes"),
      },
      {
        path: "p/:id",
        loadChildren: () =>
          import("app/layout/common/business-card/business-card.routes"),
      },

      {
        path: "privacy-policy",
        loadChildren: () =>
          import("app/modules/public/privacy-policy/privacy-policy.route"),
      },
      {
        path: "report/staff-timesheet/preview",
        loadComponent: () =>
          import("app/modules/report/resource-and-utilization/staff-timesheet-report-summary/preview/staff-timesheet-report-summary-preview.component").then(
            (m) => m.StaffTimesheetReportSummaryPreviewComponent,
          ),
      },
    ],
  },

  {
    path: "",
    component: LayoutComponent,
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    data: {
      layout: "empty",
    },
    children: [
      {
        path: "login",
        loadChildren: () => import("app/modules/auth/login/login.routes"),
      },
    ],
  },

  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: "dense",
    },
    resolve: {
      initialData: InitialDataResolver,
    },
    children: [
      {
        path: "home",
        loadChildren: () => import("app/modules/home/home.routes"),
      },
      {
        path: "booking",
        children: [
          {
            path: "overview",
            loadChildren: () =>
              import("app/modules/booking-page/overview/overview.routes"),
          },
          {
            path: "history",
            loadChildren: () =>
              import("app/modules/booking-page/history/history.routes"),
          },
        ],
      },
      {
        path: "management",
        children: [
          {
            path: "banner",
            loadChildren: () => import("app/modules/banner/banner.routes"),
          },
          {
            path: "approval",
            loadChildren: () => import("app/modules/approval/approval.routes"),
          },
          {
            path: "resource-hub",
            loadChildren: () =>
              import("app/modules/resource-hub/resource-hub.routes"),
          },
          {
            path: "resource-management",
            loadChildren: () =>
              import("app/modules/resource-management/resource-management.routes"),
          },
          {
            path: "onboarding",
            loadChildren: () =>
              import("app/modules/admin/onboarding/onboarding.routes"),
          },
          {
            path: "project-management",
            children: [
              {
                path: "boards",
                loadChildren: () =>
                  import("app/modules/project-management/project-dashboard/project-dashboard.routes"),
              },
              {
                path: "boards/project/:id",
                loadChildren: () =>
                  import("app/modules/project-management/project-gantt/project-gantt.routes"),
              },
              {
                path: "task-gate",
                loadChildren: () =>
                  import("app/modules/project-management/task-gate/task-gate.routes"),
              },
            ],
          },
          {
            path: "timesheet",
            loadChildren: () =>
              import("app/modules/timesheet-generator/timesheet-generator.route"),
          },
        ],
      },
      {
        path: "report",
        children: [
          {
            path: "analytics",
            loadChildren: () =>
              import("app/modules/report/analytic/analytic.routes"),
          },
          {
            path: "attendance",
            loadChildren: () =>
              import("app/modules/report/booking-report/booking-report-dashboard/booking-report-dasboard.routes"),
          },
          {
            path: "timesheet-utilization",
            loadChildren: () =>
              import("app/modules/report/resource-and-utilization/resource-and-utilization.routes"),
          },
        ],
      },
      {
        path: "settings",
        loadChildren: () =>
          import("app/modules/configurations/configurations.routes"),
      },
      {
        path: "changelog",
        loadChildren: () => import("app/modules/changelog/changelog.routes"),
      },
      {
        path: "feedback",
        loadChildren: () => import("app/modules/feedback/feedback.route"),
      },
      {
        path: "roadmap",
        loadChildren: () => import("app/modules/roadmap/roadmap.route"),
      },
      {
        path: "icon-viewer",
        loadChildren: () =>
          import("app/modules/admin/icon-viewer/icon-viewer.routes"),
      },
      {
        path: "error-404",
        pathMatch: "full",
        loadChildren: () =>
          import("app/modules/general/error/error-404/error-404.routes"),
      },
      { path: "**", redirectTo: "error-404" },
    ],
  },
];
